
    import './styles.scoped.css';
    export default {
  "card-inner": "awsui_card-inner_p8a6i_1il0l_97",
  "root": "awsui_root_p8a6i_1il0l_133",
  "header-variant-full-page": "awsui_header-variant-full-page_p8a6i_1il0l_175",
  "header-refresh": "awsui_header-refresh_p8a6i_1il0l_175",
  "list": "awsui_list_p8a6i_1il0l_182",
  "list-grid-1": "awsui_list-grid-1_p8a6i_1il0l_190",
  "card": "awsui_card_p8a6i_1il0l_97",
  "list-grid-2": "awsui_list-grid-2_p8a6i_1il0l_193",
  "list-grid-3": "awsui_list-grid-3_p8a6i_1il0l_196",
  "list-grid-4": "awsui_list-grid-4_p8a6i_1il0l_199",
  "list-grid-5": "awsui_list-grid-5_p8a6i_1il0l_202",
  "list-grid-6": "awsui_list-grid-6_p8a6i_1il0l_205",
  "list-grid-7": "awsui_list-grid-7_p8a6i_1il0l_208",
  "list-grid-8": "awsui_list-grid-8_p8a6i_1il0l_211",
  "list-grid-9": "awsui_list-grid-9_p8a6i_1il0l_214",
  "list-grid-10": "awsui_list-grid-10_p8a6i_1il0l_217",
  "list-grid-11": "awsui_list-grid-11_p8a6i_1il0l_220",
  "list-grid-12": "awsui_list-grid-12_p8a6i_1il0l_223",
  "list-grid-13": "awsui_list-grid-13_p8a6i_1il0l_226",
  "list-grid-14": "awsui_list-grid-14_p8a6i_1il0l_229",
  "list-grid-15": "awsui_list-grid-15_p8a6i_1il0l_232",
  "list-grid-16": "awsui_list-grid-16_p8a6i_1il0l_235",
  "list-grid-17": "awsui_list-grid-17_p8a6i_1il0l_238",
  "list-grid-18": "awsui_list-grid-18_p8a6i_1il0l_241",
  "list-grid-19": "awsui_list-grid-19_p8a6i_1il0l_244",
  "list-grid-20": "awsui_list-grid-20_p8a6i_1il0l_247",
  "selection-control": "awsui_selection-control_p8a6i_1il0l_251",
  "loading": "awsui_loading_p8a6i_1il0l_260",
  "empty": "awsui_empty_p8a6i_1il0l_261",
  "has-header": "awsui_has-header_p8a6i_1il0l_268",
  "refresh": "awsui_refresh_p8a6i_1il0l_271",
  "remove-high-contrast-header": "awsui_remove-high-contrast-header_p8a6i_1il0l_271",
  "card-header": "awsui_card-header_p8a6i_1il0l_326",
  "card-header-inner": "awsui_card-header-inner_p8a6i_1il0l_334",
  "card-selectable": "awsui_card-selectable_p8a6i_1il0l_338",
  "card-selected": "awsui_card-selected_p8a6i_1il0l_341",
  "section": "awsui_section_p8a6i_1il0l_348",
  "section-header": "awsui_section-header_p8a6i_1il0l_354",
  "section-content": "awsui_section-content_p8a6i_1il0l_360",
  "footer-pagination": "awsui_footer-pagination_p8a6i_1il0l_368"
};
  